import React from 'react';
import { HeadingContentMobile, MobileContent, MobileHeadingSection, DescriptionMobile } from '../index.styled';
import { useTranslation } from 'react-i18next';
const CONTENT_PATH = 'AboutUsPage.ResearchFacilities';
const isIE = /*@cc_on!@*/false || !!document.documentMode;

export const MobileHeading = ({image, title}) => {
  const { t } = useTranslation();
  return (
    <MobileHeadingSection>
      <HeadingContentMobile>{t(`${CONTENT_PATH}.heading.title`)}</HeadingContentMobile>
      <img src={image} alt='' role='presentation' />
      <MobileContent>
        <DescriptionMobile ie={isIE.toString()}>{t(`${CONTENT_PATH}.heading.description`)}</DescriptionMobile>
      </MobileContent>
    </MobileHeadingSection>
  )
}